export enum AcceptedRole {
  Admin = "admin",
  Labeler = "labeler",
  Inspector = "inspector",
}
